declare global {
  // tslint:disable-next-line
  interface Window {
    Rollbar: any
  }
}

export function logError(message: string, error = {}) {
  console.log(message || 'Error', error) // tslint:disable-line
  if (window.Rollbar) {
    window.Rollbar.error(message, error)
  }
}

export function logInfo(message: string, extra?: any) {
  console.log(message, extra) // tslint:disable-line
  if (window.Rollbar) {
    window.Rollbar.info(message, extra)
  }
}
